import {PageHeader} from "@ant-design/pro-layout";
import {navigateBackHandler} from "../../helpers/mainHelpers";
import {useAboutController} from "../../controllers/about-controller";
import AboutList from "./components/aboutItems-list/AboutList";
import AddActionButton from "../../components/action-buttons/addAction-button/AddActionButton";
import {useAuth} from "../../context/authContext";
import AboutModal from "./components/about-modal/AboutModal";
import ScrollToTopButton from "../../components/main-buttons/scroll-button/ScrollToTopButton";
import React from "react";
import "./style.less";

const AboutPage = () => {

  const aboutController = useAboutController()
  const {toggleModal, isModalOpen} = aboutController
  const {canManageContent} = useAuth()

  const headerActions = <>
    {canManageContent && <AddActionButton onClick={toggleModal}/>}
  </>

  return <>
    <div className='page_title'>
      <PageHeader
        title={
          <div className="page-header_title">
            <div className="page_name">Інформація про заклад</div>
          </div>
        }
        extra={headerActions}
        onBack={navigateBackHandler}
      />
    </div>
    <div className="page_content about-page">
      <AboutList aboutController={aboutController}/>
      <ScrollToTopButton elementSelector={".page_content"}/>
    </div>
    {isModalOpen && <AboutModal aboutController={aboutController}/>}
  </>
}

export default AboutPage
